/**
 * ProgressBar — 진행률 표시 바 컴포넌트
 *
 * - 0-100 범위의 value로 진행률 표시
 * - animated prop으로 펄스 애니메이션 활성화
 */

import { cn } from '../../lib/cn.js'
import styles from './ProgressBar.module.css'

interface ProgressBarProps {
  value: number
  size?: 'sm' | 'md'
  color?: 'primary' | 'success' | 'warning' | 'danger'
  showLabel?: boolean
  animated?: boolean
  className?: string
}

export function ProgressBar({
  value,
  size = 'md',
  color = 'primary',
  showLabel = false,
  animated = false,
  className,
}: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value))

  return (
    <div className={cn(styles.root, styles[size], styles[color], animated && styles.animated, className)}>
      <div className={styles.track}>
        <div
          className={styles.fill}
          style={{ width: `${clamped}%` }}
          role="progressbar"
          aria-valuenow={clamped}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      {showLabel && (
        <span className={styles.label}>{clamped}%</span>
      )}
    </div>
  )
}
